var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({class:_vm.designClass,attrs:{"items":_vm.items,"outlined":"","menu-props":{ bottom: true, offsetY: true }}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }